import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint: number = 904): boolean => {
    // Se inicializa con el ancho real para no renderizar primero la versión desktop
    const [isMobile, setIsMobile] = useState<boolean>(() => window.innerWidth < breakpoint);

    useEffect(() => {
        const checkScreen = () => setIsMobile(window.innerWidth < breakpoint);
        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, [breakpoint]);

    return isMobile;
};

export default useIsMobile;
